var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
const EXTERNAL_SIGN_IN_MUTATION = gql `
    mutation ExternalSignIn($request: ExternalSignInRequest!) {
        externalSignIn(request: $request) {
            title
            firstName
            lastName
            email
        }
    }
`;
export function useExternalSignIn(sideEffects) {
    const [externalSignInMutation, externalSignInState] = useMutation(EXTERNAL_SIGN_IN_MUTATION);
    const externalSignIn = (accessToken, provider) => __awaiter(this, void 0, void 0, function* () {
        const { data: externalSignInResponse } = yield externalSignInMutation({
            variables: { request: { accessToken, provider } },
        });
        if (externalSignInResponse === null || externalSignInResponse === void 0 ? void 0 : externalSignInResponse.externalSignIn) {
            callSideEffects(sideEffects, externalSignInResponse.externalSignIn);
        }
    });
    return { externalSignInState, externalSignIn };
}
